import { render, staticRenderFns } from "./TabRespaldos.vue?vue&type=template&id=6f20b6b3&scoped=true&"
import script from "./TabRespaldos.vue?vue&type=script&lang=js&"
export * from "./TabRespaldos.vue?vue&type=script&lang=js&"
import style0 from "./TabRespaldos.vue?vue&type=style&index=0&id=6f20b6b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20b6b3",
  null
  
)

export default component.exports